import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APGenericSlot } from '../../../global/builders/ap_generic_slot_builder';
import { APPlannedCourse } from '../../../global/builders/ap_planned_course_builder';
import { APTerm } from '../../../global/builders/ap_term_builder';
import { APStudentDetailsQuery } from '../../../global/components/student_details/queries/student_details_query';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { APGenericSlotServant } from '../../../global/servants/ap_generic_slot_servant';
import { APTermServant } from '../../../global/servants/ap_term_servant';
interface ILockingUnlockingCoursesInfo {
  termName: string;
  courseNames: string[];
}
interface IPlaceholdersInfoInfo {
  termName: string;
  placeholderNames: string[];
}
export class BulkCoursesLockUnlockController {
  private terms: APTerm[];
  private studentName = '';
  private openModal: boolean = false;
  private heading = '';
  private isTermLevelLocking: boolean = true;
  private isLocking: boolean;
  private lockingUnlockingCoursesInfo: ILockingUnlockingCoursesInfo[] = [];
  private lockUnlockButtonText = 'Lock Course(s)';
  private confirmationText = '';
  private placeholdersInfo: IPlaceholdersInfoInfo[] = [];
  private showUnlockingPlaceholderText = false;

  constructor(
    private ngAPNotificationDelegate: INotificationDelegate,
    private bulkLockUnLockCoursesCommand: ICommand,
    private ngAPStudentDetailsQuery: APStudentDetailsQuery
  ) {}
  $onInit() {
    this.initialize();
  }
  initialize() {
    this.studentName = this.ngAPStudentDetailsQuery.result.first_name;
    this.lockUnlockButtonText = this.isLocking ? 'Lock Course(s)' : 'Unlock Course(s)';
    const headingPrependText = this.isLocking ? 'Lock' : 'Unlock';
    this.confirmationText = `Are you sure you want to ${headingPrependText} these course(s)?`;

    this.placeholdersInfo = this.getUnlockedPlaceHolderDisplayInfo();
    this.lockingUnlockingCoursesInfo = this.getLockingUnlockingDisplayInformation().coursesInfo;
    const hedingAppendText = this.isTermLevelLocking ? _4.head(this.terms).name : `${this.studentName}'s Academic Plan`;
    this.heading = `${headingPrependText} ${_4.size(
      this._getLockingUnlockingCourseIds()
    )} Planned Course(s) in ${hedingAppendText}`;
    this.showUnlockingPlaceholderText = this.isLocking && !_4.isEmpty(this.placeholdersInfo);
  }

  getUnlockedPlaceHolderDisplayInfo() {
    return _4.filter(
      _4.compact(
        _4.map(this.terms, (term) => ({
          termName: term.name,
          placeholderNames: this.getUnlockedPlaceHolderNames(term)
        }))
      ),
      (placeholderInfo) => _4.gt(_4.size(placeholderInfo.placeholderNames), 0)
    );
  }

  getUnlockedPlaceHolderNames(term: APTerm) {
    return _4.compact(
      _4.map(
        _4.filter(
          term._genericSlots,
          (genericSlot: APGenericSlot) =>
            !APGenericSlotServant.isCourseSlot(genericSlot) && !_4.get(genericSlot, 'plannedCourse')
        ),
        (slot) => this._getPlaceholderTilte(slot)
      )
    );
  }

  _getPlaceholderTilte(slot: APGenericSlot) {
    const title = slot.title;
    if (!APGenericSlotServant.isNCRSlot(slot)) {
      return `${title} (Pick a course in order to lock)`;
    }
    return `${title} (These requirements cannot be locked)`;
  }

  getLockingUnlockingDisplayInformation() {
    const coursesInfo = _4.filter(
      _4.compact(
        _4.map(this.terms, (term: APTerm) => ({
          termName: term.name,
          courseNames: this._getTermLockingUnlockingCoursesInfo(term).courseNames
        }))
      ),
      (courseInfo) => _4.gt(_4.size(courseInfo.courseNames), 0)
    );
    return {
      coursesInfo
    };
  }

  _getTermLockingUnlockingCoursesInfo(term: APTerm) {
    const lockingUnlockingCourses = this.isLocking
      ? APTermServant.getAllUnLockedPlannedCourses(term)
      : APTermServant.getAllLockedPlannedCourses(term);
    const courseNames = _4.map(lockingUnlockingCourses, (plannedCourse: APPlannedCourse) =>
      _4.get(plannedCourse, '_course._title', '')
    );
    const courseIds = _4.map(lockingUnlockingCourses, (plannedCourse: APPlannedCourse) => plannedCourse.id);
    return {
      courseNames,
      courseIds
    };
  }

  _getLockingUnlockingCourseIds() {
    return _4.flatMap(this.terms, (term: APTerm) => this._getTermLockingUnlockingCoursesInfo(term).courseIds);
  }

  $onChanges() {
    this.initialize();
  }
  accept() {
    const courseIds = this._getLockingUnlockingCourseIds();
    this.bulkLockUnLockCoursesCommand(courseIds, this.isLocking).then(() => {
      this.closeDialog();
      this.ngAPNotificationDelegate.success(this._getGrowlerText());
    });
  }

  openedChanged($event: any) {
    if ($event && $event.detail && !$event.detail.value) {
      this.closeDialog();
    }
  }

  _getGrowlerText() {
    const coursesCount = _4.size(this._getLockingUnlockingCourseIds());
    const text = `${coursesCount} course(s) ${this.isLocking ? 'Locked' : 'Unlocked'};`;
    const growlerAppendText = this.isTermLevelLocking ? `in the ${_4.head(this.terms).name}` : `on the plan`;
    return `${text} ${growlerAppendText}`;
  }

  closeDialog() {
    this.openModal = false;
  }
}
angular.module('capability-ng-academic-planner').component('bulkCoursesLockUnlockModal', {
  templateUrl:
    'capability-ng-academic-planner/src/plan/components/bulk_courses_lock_unlock_modal/bulk_courses_lock_unlock_modal.html',
  bindings: {
    terms: '<',
    openModal: '=',
    isLocking: '<',
    isTermLevelLocking: '<?'
  },
  controller: BulkCoursesLockUnlockController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/bulk_courses_lock_unlock_modal/bulk_courses_lock_unlock_modal.ts